import React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';

import * as Urls from '../../constants/Urls';
import { isRouteProtected } from '../../utils/commonUtils';

const AuthenticatedRoute = ({
  loggedIn,
  userRights,
  appSettings,
  component: Component,
  ...moreProps
}) => {
  const renderComponent = (p) => {
    return loggedIn !== true ? (
      <Redirect
        to={{
          pathname: Urls.LOGIN,
          state: { from: p.location },
        }}
      />
    ) : isRouteProtected(moreProps.location, userRights, appSettings) ? (
      <Redirect
        to={{
          pathname: Urls.HOME,
        }}
      />
    ) : (
      <Component {...p} />
    );
  };

  return <Route {...moreProps} render={renderComponent} />;
};

const mapStateToProps = (state) => ({
  loggedIn: state.auth.logged_in,
  userRights: state.userRights,
  appSettings: state.appSettings,
});

export default connect(mapStateToProps)(AuthenticatedRoute);
